<template>
  <div class="m-grid__item m-grid__item--fluid m-wrapper">
    <div class="m-subheader ">
      <div class="d-flex align-items-center">
        <div class="mr-auto">
          <h3 class="m-subheader__title ">

          </h3>
        </div>
      </div>
    </div>
    <div class="m-content">
      <div class="about-margin m--padding-30 text-center">
        <div class="panel-title">
          <span class="">
            <img class="navbar-brand-logo" src="../../../static/img/makueni-logo.png" title="zizi logo">
          </span>
        </div>
        <div class="m-portlet__body">
          <div class="page-error page-error-404">
            <div class="vertical-align text-center">
              <div class="page-content vertical-align-middle">
                <header>
                  <h1 class="animation-slide-top">404</h1>
                  <p>Page Not Found !</p>
                </header>
                <p class="error-advise">THE PAGE YOU ARE LOOKING FOR COULD NOT BE FOUND.</p>
                <router-link class="btn btn-primary" to="/">GO TO HOME PAGE</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/errors/NotFoundView.vue